import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AlloxCommonAsyncPipe, IAlloxAsyncPipeIDNameList, IAlloxAsyncPipeOption } from './allox-common-async.pipe';
import { OS, OSService } from '@app/core';
import { OSSearchParam } from '@app/core/models/os-search-param.model';

interface IOSPipeOption extends IAlloxAsyncPipeOption {
  name?: boolean;
}
@Pipe({
    name: 'os', pure: false,
    standalone: false
})
export class OSPipe
  extends AlloxCommonAsyncPipe<OS>
  implements IAlloxAsyncPipeIDNameList<OS>, PipeTransform {

  constructor(private service: OSService, changeDetectorRef: ChangeDetectorRef, router: Router) {
    super(changeDetectorRef, router);
  }

  loadDependency() {
    return this.service.search(new OSSearchParam());
  }

  makeText(value: number, obj: OS, option?: IOSPipeOption) {
    if (!obj) {
      return `Unknown [id: ${value}]`;
    }
    return obj.name;
  }

}
